import React from 'react';
import { WeekChart } from '../components/WeekChart';
import { usePomodoro } from '../contexts/PomodoroContext';
import { formatMinutes } from '../utils/time';
export function ProgressScreen() {
  const {
    sessions,
    todayMinutes,
    todaySessions,
    settings
  } = usePomodoro();
  const goal = settings.dailyGoal;
  return <div className="flex min-h-full flex-col px-5 pb-24 pt-[max(1rem,env(safe-area-inset-top))]" data-id="element-99" data-mp="mjxc58kv8sfh">
      <header data-id="element-100" data-mp="3l3ncverfa6r4">
        <h1 className="text-sm font-semibold tracking-tight text-ink" data-id="element-101" data-mp="3l46xx4cddb9d">Progress</h1>
      </header>

      <div className="mx-auto mt-6 w-full max-w-sm" data-id="element-102" data-mp="3q28ftly274j9">
        {sessions.length === 0 ? <div className="mt-16 text-center" data-id="element-103" data-mp="3v007ceuskomx">
            <p className="text-base font-medium text-ink" data-id="element-104" data-mp="3m46vzmrs6ex">No sessions yet</p>
            <p className="mx-auto mt-2 max-w-[260px] text-sm leading-relaxed text-muted" data-id="element-105" data-mp="3nfde77lns9q">
              Finish your first focus session and it will show up here — nothing is counted until a session
              completes.
            </p>
          </div> : <>
            <section aria-labelledby="today-heading" data-id="element-106" data-mp="2ejrlpqn9s7sx">
              <h2 id="today-heading" className="text-xs font-medium uppercase tracking-wide text-muted" data-id="element-107" data-mp="29lg7z4tutd5f">
                Today
              </h2>
              <div className="mt-3 flex items-end gap-8" data-id="element-108" data-mp="24swz2l64366y">
                <p className="flex flex-col" data-id="element-109" data-mp="20tefbsq1115p">
                  <span className="tabular text-3xl font-semibold text-ink" data-id="element-110" data-mp="20smh0a51opbq">{todaySessions}</span>
                  <span className="mt-1 text-xs text-muted" data-id="element-111" data-mp="1vv32ra8ckcjs">
                    {todaySessions === 1 ? 'session' : 'sessions'}
                  </span>
                </p>
                <p className="flex flex-col" data-id="element-112" data-mp="1lwn9b0lukr74">
                  <span className="tabular text-3xl font-semibold text-ink" data-id="element-113" data-mp="1lxf7mj6tx313">{todayMinutes}</span>
                  <span className="mt-1 text-xs text-muted" data-id="element-114" data-mp="1hwd61vpfwevy">focus minutes</span>
                </p>
              </div>

              {goal !== null && <div className="mt-5" data-id="element-115" data-mp="3c931wizdby5z">
                  <div className="flex items-baseline justify-between text-xs text-muted" data-id="element-116" data-mp="3c5xdz72h72bu">
                    <span data-id="element-117" data-mp="19j9tqqbwgoi1">Daily goal</span>
                    <span className="tabular" data-id="element-118" data-mp="1ecmid0gkwvas">
                      {todayMinutes} / {goal} min
                    </span>
                  </div>
                  <div role="progressbar" aria-label="Daily focus goal progress" aria-valuemin={0} aria-valuemax={goal} aria-valuenow={todayMinutes} className="mt-2 h-[3px] w-full overflow-hidden rounded-full bg-line" data-id="element-119" data-mp="10mj1kp0gxtsq">
                    <div className="h-full rounded-full bg-coral transition-[width] duration-200 ease-calm" style={{
                width: `${Math.min(100, Math.round(todayMinutes / goal * 100))}%`
              }} data-id="element-120" data-mp="1jbz39fnw3saq" />
                  </div>
                  {todayMinutes >= goal && <p className="mt-2 text-xs font-medium text-coral" data-id="element-121" data-mp="cvvhz6h6xfqc">Daily goal reached.</p>}
                </div>}
            </section>

            <section aria-labelledby="week-heading" className="mt-10" data-id="element-122" data-mp="d9jelucbxvj">
              <h2 id="week-heading" className="text-xs font-medium uppercase tracking-wide text-muted" data-id="element-123" data-mp="ec96vq64a6q4">
                Last 7 days
              </h2>
              <div className="mt-4" data-id="element-124" data-mp="9ehfcx9dwmmg">
                <WeekChart sessions={sessions} data-id="element-125" data-mp="9bd6vnovz4pz" />
              </div>
              <p className="mt-4 text-xs text-muted" data-id="element-126" data-mp="3htj0a1a4c0d8">
                {formatMinutes(sessions.reduce((sum, s) => sum + s.minutes, 0))} focused in total across{' '}
                {sessions.length} {sessions.length === 1 ? 'session' : 'sessions'}.
              </p>
            </section>
          </>}
      </div>
    </div>;
}